import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet, View } from 'react-native'
import { BetKind } from '@ppwr/poker'
import { useStore } from '../../../../../models'
import { DS } from '../../../../../design-system'
import { palette } from '../../../../../theme/palette'
import { PlayerChips } from '../../../PlayerChips'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export interface ThreeCardBetProps {
  onClose: () => void
}

export const ThreeCardBet = observer(({ onClose }: ThreeCardBetProps) => {
  const {
    game: { biggestBet, doBetForPlayer, doAllInForPlayer, minimumRaise }
  } = useStore()

  if (!minimumRaise) return null

  const isRaise = Boolean(biggestBet)

  const handleBet = async (amount: number) => {
    onClose()
    await doBetForPlayer(amount, isRaise ? BetKind.RAISE : BetKind.BET)
  }

  const handleAllIn = async () => {
    onClose()
    await doAllInForPlayer()
  }

  return (
    <BottomSheetView style={Platform.OS !== 'web' ? { flex: 1 } : {}}>
      <View style={styles.container}>
        <DS.Text variant="Heading 5/Medium" textAlign="center">
          How much do you want to {isRaise ? 'raise' : 'bet'}?
        </DS.Text>
        <View style={styles.actions}>
          <BetButton
            minimumRaise={minimumRaise}
            multiplier={1}
            onBet={handleBet}
            onAllIn={handleAllIn}
            isRaise={isRaise}
          />
          <BetButton
            minimumRaise={minimumRaise}
            multiplier={2}
            onBet={handleBet}
            onAllIn={handleAllIn}
            isRaise={isRaise}
          />
        </View>
      </View>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: palette.cream,
    paddingHorizontal: 20
  },
  actions: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: 20
  }
})

const BetButton = ({
  minimumRaise,
  multiplier,
  onBet,
  onAllIn,
  isRaise
}: {
  minimumRaise: number
  multiplier: number
  onBet: (amount: number) => Promise<void>
  onAllIn: () => Promise<void>
  isRaise: boolean
}) => {
  const {
    game: { myPlayer, isRaiseAllInForMyPlayer }
  } = useStore()

  const isAllIn = isRaiseAllInForMyPlayer(multiplier)
  const text = isAllIn ? 'Raise All' : `${isRaise ? 'Raise' : 'Bet'} ${multiplier}x`
  const chips = isAllIn ? myPlayer?.chips : minimumRaise * multiplier
  const handleBet = async (amount: number) => {
    if (isAllIn) {
      await onAllIn()
    } else {
      await onBet(amount)
    }
  }

  return (
    <View style={{ alignItems: 'center', flex: 1, gap: 2 }}>
      <DS.Button
        type="On Light"
        variant="Large/Primary"
        rightIcon={<DS.Icon name="Arrow--top-right" color="Global/White" size={16} />}
        onPress={async () => await handleBet(minimumRaise * multiplier)}
      >
        {text}
      </DS.Button>
      <PlayerChips chips={chips} color={'Global/Black'} chipsSize={12} />
    </View>
  )
}
